import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

// Merge saved data over defaults so any key not saved falls back to hardcoded value.
function merge(defaults, saved) {
  if (!saved || typeof saved !== "object") return defaults;
  const out = { ...defaults };
  for (const k of Object.keys(saved)) {
    if (saved[k] !== null && saved[k] !== undefined && saved[k] !== "") out[k] = saved[k];
  }
  return out;
}

export function useSiteContent(key, defaults) {
  const [data, setData] = useState(defaults);
  const [loaded, setLoaded] = useState(false);

  const reload = useCallback(async () => {
    try {
      const { data: resp } = await api.get(`/site-content/${key}`);
      setData(merge(defaults, resp.data));
    } catch {
      setData(defaults);
    } finally {
      setLoaded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  useEffect(() => { reload(); }, [reload]);

  const save = async (newData) => {
    await api.post(`/site-content/${key}`, { data: newData });
    await reload();
  };

  return { data, loaded, save, reload };
}
